import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import { Modal, Table, Select, Avatar, message, Input, Switch, Tabs } from "antd";
import Header from "../components/header/HeaderHome";
import AWS from "aws-sdk";

import { GetMongoUserByUidAction, getSchoolInfoByIdAction, FindStudentBySchoolAction, SchoolStatusChangeAction, GetStudentSchoolCourseAction, getmatchschoolcourseAction, AssignCourseToUserAction, DelCourseToUserAction, GetManyUsersFromFirebase, CourseSubscriptionActionFromSchoolAdmin, DeleteStudentFromSchool, GetManyUserSchoolLevels, UpdateMongoUserSchoolLevel, AssignSchoolTeacherAction, RemoveSchoolTeacherAction, GetSchoolTeachersAction, GetSchoolListAction, GetCoursesBySchoolIdAction, CopyCourseFromSchoolAction, DeleteSchoolCourseAction, GetSchoolCourseDeleteLogsAction, UpdateSchoolCertificateAction } from "../actions";
import { GlobalContext } from "../hook/GlobalHook";
import { getSubjectLevels } from "../actions";

const { Option } = Select;
const { TabPane } = Tabs;

const { Column, ColumnGroup } = Table;
export default function Dashboard() {
  const GlobalHook = useContext(GlobalContext);
  const [getSelectedStudent, setSelectedStudent] = useState(null);
  const [getModalAddMyNewCourseOpenStatus, setModalAddMyNewCourseOpenStatus] = useState(false)
  const [getLocalMatchCourseSchool, setLocalMatchCourseSchool] = useState([])
  const [getLocalMatchStudentCourseSchool, setLocalMatchStudentCourseSchool] = useState([])
  const [getSelectedMongoStudent, setSelectedMongoStudent] = useState(null)

  const [getStudentList, setStudentList] = useState([])
  const [getSearchText, setSearchText] = useState("");
  const [getLevels, setLevels] = useState([]);
  const [userLevels, setUserLevels] = useState({});
  const [getTeacherList, setTeacherList] = useState([]);
  const [getTeacherEmail, setTeacherEmail] = useState("");

  const [getSchoolList, setSchoolList] = useState([]);
  const [getCopySourceSchoolId, setCopySourceSchoolId] = useState("");
  const [getCopySourceCourses, setCopySourceCourses] = useState([]);
  const [getCopySourceCourseId, setCopySourceCourseId] = useState("");
  const [getCopyCourseName, setCopyCourseName] = useState("");
  const [getDeleteLogs, setDeleteLogs] = useState([]);
  const [getActiveTab, setActiveTab] = useState("students");

  const [getCertEnabled, setCertEnabled] = useState(true);
  const [getCertBackground, setCertBackground] = useState("");
  const [getCertPreviewBg, setCertPreviewBg] = useState("");
  const [getCertBgBroken, setCertBgBroken] = useState(false);
  const [getCertUploading, setCertUploading] = useState(false);
  const [getCertPreviewName, setCertPreviewName] = useState("Student Name");

  useEffect(() => {
    if (GlobalHook.getGlobalUser) {
      FindStudentBySchoolAction(
        GlobalHook,
        GlobalHook.getGlobalUser.schoolAdminId
      );
      getmatchschoolcourseAction(GlobalHook, GlobalHook.getGlobalUser.schoolAdminId)
      getSchoolInfoByIdAction(GlobalHook, GlobalHook.getGlobalUser.schoolAdminId)

      GetSchoolTeachersAction(GlobalHook.getGlobalUser.schoolAdminId).then(setTeacherList);
      GetSchoolListAction().then(setSchoolList);
      GetSchoolCourseDeleteLogsAction(GlobalHook.getGlobalUser.schoolAdminId).then(setDeleteLogs);
    }
  }, [GlobalHook.getGlobalUser]);

  useEffect(() => {
    if (!getCopySourceSchoolId) {
      setCopySourceCourses([]);
      setCopySourceCourseId("");
      return;
    }
    GetCoursesBySchoolIdAction(getCopySourceSchoolId).then((courses) => {
      setCopySourceCourses(courses || []);
      setCopySourceCourseId("");
    });
  }, [getCopySourceSchoolId]);

  useEffect(() => {
    const info = GlobalHook.getGlobalSchoolInfo;
    if (info && info._id) {
      setCertEnabled(info.certificateEnabled !== false);
      setCertBackground(info.certificateBackground || "");
      setCertPreviewBg(info.certificateBackground || "");
      setCertBgBroken(false);
    }
  }, [GlobalHook.getGlobalSchoolInfo]);

  function saveCertificateSettings(backgroundUrl, enabled) {
    return UpdateSchoolCertificateAction(
      GlobalHook,
      GlobalHook.getGlobalUser.schoolAdminId,
      backgroundUrl,
      enabled
    );
  }

  function uploadCertificateBackground(file) {
    if (!file) return;

    // Instant local preview (does not wait for upload)
    const localUrl = URL.createObjectURL(file);
    setCertPreviewBg(localUrl);
    setCertBgBroken(false);
    setCertUploading(true);

    const spacesEndpoint = new AWS.Endpoint("sgp1.digitaloceanspaces.com");
    const S3 = new AWS.S3({
      endpoint: spacesEndpoint,
      accessKeyId: "RQCZPP26IBCSMVIKVVDX",
      secretAccessKey: "6MKKW0aMCBtX66laRDLcRkbXGk5tTwPc30mICrxz2/E",
    });
    const safeName = String(file.name || "certificate.jpg").replace(/[^\w.\-]/g, "_");
    const key = `certificates/${Date.now()}-${safeName}`;
    const params = { Body: file, Bucket: "studysabaiapp", Key: key };

    S3.putObject(params)
      .on("build", (request) => {
        request.httpRequest.headers.Host =
          "https://studysabaiapp2.sgp1.digitaloceanspaces.com";
        request.httpRequest.headers["Content-Length"] = file.size;
        request.httpRequest.headers["Content-Type"] = file.type || "image/jpeg";
        request.httpRequest.headers["x-amz-acl"] = "public-read";
      })
      .send((err) => {
        setCertUploading(false);
        if (err) {
          console.log(err);
          message.error("Upload failed. Preview is local only — try again or paste an image URL.");
          return;
        }
        const url = `https://studysabaiapp2.sgp1.digitaloceanspaces.com/${key}`;
        setCertBackground(url);
        setCertPreviewBg(url);
        setCertEnabled(true);
        setCertBgBroken(false);
        message.success("Background uploaded — saving...");
        saveCertificateSettings(url, true)
          .then(() => message.success("Certificate saved"))
          .catch(() => {});
      });
  }

  useEffect(() => {
    GlobalHook.setGlobalLoading(true);

    if (GlobalHook.getGlobalMatchStudentBySchool.length > 0) {
      GetManyUsersFromFirebase(GlobalHook.getGlobalMatchStudentBySchool)
        .then(firebaseUserList => {

          var tempStudentList = GlobalHook.getGlobalMatchStudentBySchool.map((item, index) => {
            return {
              key: index,
              profile: "https://robohash.org/hicdoloribussunt.png?size=50x50&set=set1",
              name: item.uid,
              status: item.schoolApproved ? "Approved" : "Waiting",
              uid: item.uid,
              schoolApproved: item.schoolApproved,
              level: null
            }
          })

          for (var item of tempStudentList) {
            var matchStudent = firebaseUserList.filter(firebaseUser => item.uid == firebaseUser.uid)
            if (matchStudent.length == 1) {
              item.profile = matchStudent[0].photoURL;
              item.name = matchStudent[0].displayName;
            }
          }

          setStudentList(tempStudentList)
          GlobalHook.setGlobalLoading(false);

        })
        .catch(error => {
          console.log(error)
        })
    }
  }, [GlobalHook.getGlobalMatchStudentBySchool, GlobalHook.getGlobalUser])

  useEffect( () => {

  }, [GlobalHook.getGlobalSchoolInfo])


  useEffect(() => {
    if (GlobalHook.getGlobalMatchCourseSchool, GlobalHook.getGlobalUser) {

      setLocalMatchCourseSchool(GlobalHook.getGlobalMatchCourseSchool.map((item, index) => {
        return {
          key: index,
          Cover: item.courseImage,
          CourseName: item.courseName,
          courseId: item._id
        }
      }))
    }
  }, [GlobalHook.getGlobalMatchCourseSchool, GlobalHook.getGlobalUser])


  useEffect(() => {
    if (GlobalHook.getGlobalMatchStudentCourseSchool) {
      setLocalMatchStudentCourseSchool(GlobalHook.getGlobalMatchStudentCourseSchool.map((item, index) => {
        return {
          key: index,
          cover: item.cover,
          courseName: item.courseName,
          courseId: item.courseId
        }
      }))
    }
  }, [GlobalHook.getGlobalMatchStudentCourseSchool, GlobalHook.getGlobalUser])

  useEffect(() => {
    getSubjectLevels()
      .then(data => {
        for (var x of data) {
          if (x.type == "levelmenu") {
            setLevels(x.menu);
          }
        }
        GlobalHook.setGlobalCourseLevelFilter("ทั้งหมด");
      })
      .catch(error => {
        console.log(error);
      });
  }, [GlobalHook]);

  function RenderAddMyNewCourseModal() {
    return (
      <Modal
        visible={getModalAddMyNewCourseOpenStatus}
        title="Add School Course"
        onOk={() => setModalAddMyNewCourseOpenStatus(false)}
        onCancel={() => {
          setModalAddMyNewCourseOpenStatus(false);
        }}
        footer={[
          <div className="w-full flex justify-center">

          </div>
        ]}
      >
        <div className="flex flex-col justify-center items-center mx-auto">
          <div className="flex mb-4">
            <Table
              dataSource={getLocalMatchCourseSchool}

              className="mt-4"
            >
              <Column
                title="Cover"
                dataIndex="Cover"
                key="Cover"
                className="cursor-pointer"
                render={Cover => <Avatar size={40} src={Cover} />}
              />
              <Column
                title="CourseName"
                dataIndex="CourseName"
                key="CourseName"
                className="cursor-pointer"
              />


              <Column
                title="Action"
                key="action"
                render={(text, record) => (
                  <div
                    className="ml-2 bg-green-500 hover:bg-green-400 cursor-pointer p-2 rounded-full flex justify-center items-center text-white"
                    style={{ width: "20px", height: "20px" }}
                    onClick={() => {

                      var filterRes = getLocalMatchStudentCourseSchool.filter(item => item.courseId == record.courseId)

                      setModalAddMyNewCourseOpenStatus(false);

                      var timeNow = Date.now();
                      // only add new subsciption if user has never previously subscribed to course, otherwise we will only update existing data and not add new one
                      // check if assigned course is a new course that has never been subscribed by student
                      const studentPreviouslySubsribed = getSelectedMongoStudent.courseSubscription.filter( course => course.courseId == record.courseId)
                      if (studentPreviouslySubsribed[0]) {
                        
                          // AssignCourseToUserAction(GlobalHook, getSelectedStudent.uid, GlobalHook.getGlobalUser.schoolAdminId, record.courseId)

                        var studentPreviouslyAssigned = []
                        for (var school of getSelectedMongoStudent.schoolCourse) {
                          if (school.schoolId == GlobalHook.getGlobalSchoolInfo._id) {
                            studentPreviouslyAssigned = school.SchoolCourseList.filter( course => course._id == record.courseId)
                          }
                        }

                        if (studentPreviouslyAssigned.length==0) {
                          AssignCourseToUserAction(GlobalHook, getSelectedStudent.uid, GlobalHook.getGlobalUser.schoolAdminId, record.courseId).then( res => {
                            // get user by uid and overwrite on to getSelectedMongoStudent
                            GetMongoUserByUidAction(getSelectedStudent.uid).then( res => {
                              setSelectedMongoStudent(res)
                            })
                          })
                        }

                      } else {
                        CourseSubscriptionActionFromSchoolAdmin(GlobalHook, record.courseId, getSelectedStudent.uid, timeNow).then( res => {
                          setSelectedMongoStudent(res.data)

                          var studentPreviouslyAssigned = []
                          for (var school of getSelectedMongoStudent.schoolCourse) {
                            if (school.schoolId == GlobalHook.getGlobalSchoolInfo._id) {
                              studentPreviouslyAssigned = school.SchoolCourseList.filter( course => course._id == record.courseId)
                            }
                          }
                          // only assign course to student if never previously assigned by school
                          if (studentPreviouslyAssigned.length==0) {
                            AssignCourseToUserAction(GlobalHook, getSelectedStudent.uid, GlobalHook.getGlobalUser.schoolAdminId, record.courseId).then( res => {
                              // console.log('pernacao', res.data)
                              // setSelectedMongoStudent(res.data)
                            })
                          }
                        })
                      }



                    }}
                  >
                    +
                  </div>
                )}
              />
            </Table>
          </div>
        </div>
      </Modal>
    );
  }

  const filteredStudentList = getStudentList.filter((student) =>
    Object.values(student)
      .join(" ")
      .toLowerCase()
      .includes(getSearchText.toLowerCase())
  );

  useEffect(() => {
    if (!filteredStudentList || filteredStudentList.length === 0) return;

    async function fetchAllLevels() {
      const uidList = filteredStudentList.map(s => s.uid);
      const userLevelDocs = await GetManyUserSchoolLevels(uidList);
      const levelsMap = {};
      userLevelDocs.forEach(doc => (levelsMap[doc.uid] = doc.level));
      setUserLevels(levelsMap);
    }

    fetchAllLevels();
  }, [JSON.stringify(filteredStudentList)]);

  const handleLevelChange = async (uid, newLevel) => {
    try {
      await UpdateMongoUserSchoolLevel(uid, newLevel);
      message.success("Updated successfully!");
    } catch (err) {
      console.error(err);
      message.error("Failed to update level");
    }
  };



function renderLevelsDropDown(record) {
  const defaultLevel = userLevels[record.uid] || "ระบุระดับชั้น";

  const handleLevelChange = async (newLevel) => {
    try {
      // ✅ update state instantly for visual feedback
      setUserLevels(prev => ({ ...prev, [record.uid]: newLevel }));

      // ✅ send to backend
      await UpdateMongoUserSchoolLevel(record.uid, newLevel);

      message.success("อัปเดตระดับชั้นเรียบร้อยแล้ว");
    } catch (err) {
      console.error(err);
      message.error("เกิดข้อผิดพลาดในการอัปเดตระดับชั้น");
    }
  };

  return (
    <Select
      style={{ width: 140 }}
      placeholder="ระบุระดับชั้น"
      value={defaultLevel}
      onChange={handleLevelChange} // 👈 here
    >
      {getLevels
        .filter(lv => lv.menuThai !== "ทั้งหมด")
        .map((lv, index) => (
          <Option key={index} value={lv.menuThai}>
            {lv.menuThai}
          </Option>
        ))}
    </Select>
  );
}

  return (
    <>
      {RenderAddMyNewCourseModal()}
      <Header />
      <div className=" h-full w-full flex flex-col items-center py-4 justify-start">


        <div className="w-10/12 rounded-lg text-center text-white py-2 text-2xl font-bold mb-6 md:mb-8 bg-green-500">
          School Admin: {" "} {GlobalHook.getGlobalSchoolInfo.schoolName}
        </div>

        <div className="w-10/12 bg-white p-4 rounded-lg">
          <Tabs
            activeKey={getActiveTab}
            onChange={setActiveTab}
            size="large"
            type="card"
          >
            <TabPane tab="Students" key="students">
              <div className="flex flex-row flex-wrap justify-around w-full">
                {GlobalHook.getGlobalSchoolInfo &&  <>
                <div className="" style={{ width: "auto" }}>
                  <div className="mb-4 font-semibold text-xl">
                     {"Max Quota: " + GlobalHook.getGlobalSchoolInfo.schoolMaxQuota + ", Used Quota: " + GlobalHook.getGlobalSchoolInfo.schoolUsedQuota}
                  </div>
                  
                  <Input.Search
                    placeholder="ค้นหานักเรียน..."
                    allowClear
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ marginBottom: 16, width: 300 }}
                  />
                  <Table
                    dataSource={filteredStudentList}
                    onRowClick={e => {
                      if (e.schoolApproved) {
                        setSelectedStudent(e);

                        GetStudentSchoolCourseAction(GlobalHook, e.uid, getLocalMatchCourseSchool)

                        GetMongoUserByUidAction( e.uid).then( res => {
                          setSelectedMongoStudent(res)
                        })
                      }

                    }}
                  >
                    <Column
                      title="Profile"
                      dataIndex="profile"
                      key="Profile"
                      className="cursor-pointer"
                      render={Profile => <Avatar size={40} src={Profile} />}
                    />
                    <Column
                      title="Name"
                      dataIndex="name"
                      key="Name"
                      className="cursor-pointer"
                    />

                    <Column
                      title="Level"
                      dataIndex="level"
                      key="Level"
                      render={(text, record) => (
                        <React.Fragment key={userLevels[record.uid] || record.uid}>
                          {renderLevelsDropDown(record)}
                        </React.Fragment>
                      )}
                    />


                    <Column
                      title="Status"
                      dataIndex="status"
                      key="Status"
                      className="cursor-pointer"
                    />

                    <Column
                      title="Action"
                      key="action"
                      render={(text, record) => (
                        <span>
                          <a
                            className="text-green-500 hover:text-green-400"
                            style={{ marginRight: 16 }}
                            onClick={() => {
                              
                              var usedCount = GlobalHook.getGlobalSchoolInfo.schoolUsedQuota;
                              if ((usedCount <= GlobalHook.getGlobalSchoolInfo.schoolMaxQuota) && record.status == "Waiting") {
                                usedCount++;
                                SchoolStatusChangeAction(GlobalHook, true, record.uid, usedCount)
                              } else {
                                message.warning("User is already registerd to school.")
                              }

                            }}
                          >
                            ยืนยัน
                          </a>
                          <a className="text-red-500 hover:text-red-400"
                            onClick={() => {
                                DeleteStudentFromSchool(GlobalHook, record.uid);
                                message.success("Delete student from school success !!!")
                            }}
                          >ลบ</a>
                        </span>
                      )}
                    />
                  </Table>
                </div> </> }
               
                <div
                  className=" flex flex-col p-2"
                  style={{ width: "500px" }}
                >
                  {getSelectedStudent && <>
                    <div className="bg-yellow-400 flex justify-around items-center" style={{height:"10vh"}}>
                      <Avatar
                        size={40}
                        className="cursor-pointer"
                        src={getSelectedStudent.profile}
                      />
                      <div>{getSelectedStudent.name}</div>
                      <div style={{color:(getSelectedStudent.status)? "green": "red"}}>{getSelectedStudent.status}</div>
                    </div>
                    <div className="flex mt-4">
                      <div> Assigned Course:</div>

                      <div
                        className="ml-2 bg-orange-500 hover:bg-orange-400 cursor-pointer p-2 rounded-full flex justify-center items-center text-white"
                        style={{ width: "20px", height: "20px" }}
                        onClick={() => { setModalAddMyNewCourseOpenStatus(true) }}
                      >
                        +
                    </div>
                    </div>
                    <Table
                      dataSource={getLocalMatchStudentCourseSchool}
                      className="mt-4"
                    >
                      <Column
                        title="Cover"
                        dataIndex="cover"
                        key="Cover"
                        className="cursor-pointer"
                        render={Cover => <Avatar size={40} src={Cover} />}
                      />
                      <Column
                        title="CourseName"
                        dataIndex="courseName"
                        key="CourseName"
                        className="cursor-pointer"
                      />

                      <Column
                        title="Action"
                        key="action"
                        render={(text, record) => (
                          <span>

                            <a className="text-red-500 hover:text-red-400"
                              onClick={() => {
                                DelCourseToUserAction(GlobalHook, getSelectedStudent.uid, GlobalHook.getGlobalUser.schoolAdminId, record.courseId)
                              }}
                            >ลบ</a>
                          </span>
                        )}
                      />
                    </Table>
                  </>
                  }
                </div>
              </div>
            </TabPane>

            <TabPane tab="Courses" key="courses">
              <div className="font-semibold text-xl mb-4">School Courses</div>
              <Table
                dataSource={getLocalMatchCourseSchool}
                pagination={false}
              >
                <Column
                  title="Cover"
                  dataIndex="Cover"
                  key="Cover"
                  render={(Cover) => <Avatar size={40} src={Cover} />}
                />
                <Column title="CourseName" dataIndex="CourseName" key="CourseName" />
                <Column
                  title="Action"
                  key="action"
                  render={(text, record) => (
                    <a
                      className="text-red-500"
                      onClick={() => {
                        if (
                          !window.confirm(
                            "Delete this course from your school? This cannot be undone."
                          )
                        ) {
                          return;
                        }
                        DeleteSchoolCourseAction(
                          GlobalHook,
                          GlobalHook.getGlobalUser.schoolAdminId,
                          record.courseId
                        ).then(() => {
                          getmatchschoolcourseAction(
                            GlobalHook,
                            GlobalHook.getGlobalUser.schoolAdminId
                          );
                          GetSchoolCourseDeleteLogsAction(
                            GlobalHook.getGlobalUser.schoolAdminId
                          ).then(setDeleteLogs);
                        });
                      }}
                    >
                      Delete
                    </a>
                  )}
                />
              </Table>

              <div className="font-semibold text-xl mb-4 mt-8">Course Delete Log</div>
              <Table
                dataSource={getDeleteLogs.map((log, i) => ({
                  ...log,
                  key: log._id || i,
                  deletedAtText: log.deletedAt
                    ? new Date(log.deletedAt).toLocaleString()
                    : "-",
                }))}
                pagination={{ pageSize: 10 }}
              >
                <Column title="Course" dataIndex="courseName" key="courseName" />
                <Column title="Slug" dataIndex="courseSlug" key="courseSlug" />
                <Column title="Deleted By" dataIndex="deletedByEmail" key="deletedByEmail" />
                <Column title="Name" dataIndex="deletedByName" key="deletedByName" />
                <Column title="When" dataIndex="deletedAtText" key="deletedAtText" />
              </Table>
            </TabPane>

            <TabPane tab="Copy Course" key="copy">
              <div className="font-semibold text-xl mb-4">Copy Course From Another School</div>
              <div className="flex flex-col" style={{ gap: 12, maxWidth: 520 }}>
                <div>
                  <div className="mb-1">Source school</div>
                  <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="Select school"
                    value={getCopySourceSchoolId || undefined}
                    onChange={(value) => setCopySourceSchoolId(value)}
                    style={{ width: "100%" }}
                  >
                    {getSchoolList
                      .filter(
                        (s) =>
                          String(s._id) !==
                          String(GlobalHook.getGlobalUser.schoolAdminId)
                      )
                      .map((s) => (
                        <Option key={s._id} value={s._id}>
                          {s.schoolName}
                        </Option>
                      ))}
                  </Select>
                </div>

                <div>
                  <div className="mb-1">Course to copy</div>
                  <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="Select course"
                    value={getCopySourceCourseId || undefined}
                    onChange={(value) => {
                      setCopySourceCourseId(value);
                      const match = getCopySourceCourses.find(
                        (c) => String(c._id) === String(value)
                      );
                      if (match && !getCopyCourseName) {
                        setCopyCourseName(match.courseName + " (copy)");
                      }
                    }}
                    style={{ width: "100%" }}
                    disabled={!getCopySourceSchoolId}
                  >
                    {getCopySourceCourses.map((c) => (
                      <Option key={c._id} value={c._id}>
                        {c.courseName}
                      </Option>
                    ))}
                  </Select>
                </div>

                <div>
                  <div className="mb-1">New course name (optional)</div>
                  <Input
                    placeholder="Leave blank to use original name + (copy)"
                    value={getCopyCourseName}
                    onChange={(e) => setCopyCourseName(e.target.value)}
                  />
                </div>

                <button
                  className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded"
                  style={{ width: 160 }}
                  onClick={() => {
                    if (!getCopySourceCourseId) {
                      message.warning("Please select a course to copy");
                      return;
                    }
                    CopyCourseFromSchoolAction(
                      GlobalHook,
                      getCopySourceCourseId,
                      GlobalHook.getGlobalUser.schoolAdminId,
                      getCopyCourseName
                    ).then(() => {
                      setCopySourceCourseId("");
                      setCopyCourseName("");
                      getmatchschoolcourseAction(
                        GlobalHook,
                        GlobalHook.getGlobalUser.schoolAdminId
                      );
                    });
                  }}
                >
                  Copy Course
                </button>
              </div>
            </TabPane>

            <TabPane tab="Certificate" key="certificate">
              <div className="font-semibold text-xl mb-4">Certificate Settings</div>
              <div className="flex flex-col" style={{ gap: 12, maxWidth: 920 }}>
                <div className="flex items-center" style={{ gap: 12 }}>
                  <span>Enable certificate for finished students</span>
                  <Switch checked={getCertEnabled} onChange={setCertEnabled} />
                </div>
                <div>
                  <div className="mb-1">Background image URL (optional)</div>
                  <Input
                    placeholder="https://..."
                    value={getCertBackground}
                    onChange={(e) => {
                      setCertBackground(e.target.value);
                      setCertPreviewBg(e.target.value);
                      setCertBgBroken(false);
                    }}
                  />
                </div>
                <div>
                  <div className="mb-1">Or upload background image</div>
                  <input
                    type="file"
                    accept="image/jpeg,image/png,image/jpg,image/webp"
                    onChange={(e) => {
                      const file = e.target.files && e.target.files[0];
                      uploadCertificateBackground(file);
                      e.target.value = "";
                    }}
                  />
                  {getCertUploading && (
                    <div className="text-blue-500 mt-1">Uploading & saving...</div>
                  )}
                </div>
                <div>
                  <div className="mb-1">Preview student name</div>
                  <Input
                    value={getCertPreviewName}
                    onChange={(e) => setCertPreviewName(e.target.value)}
                    style={{ maxWidth: 360 }}
                  />
                </div>

                <div>
                  <div className="mb-2 font-semibold">Certificate Preview</div>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      maxWidth: 840,
                      aspectRatio: "297 / 210",
                      borderRadius: 8,
                      overflow: "hidden",
                      boxShadow: "0 8px 28px rgba(0,0,0,0.18)",
                      background:
                        "linear-gradient(145deg, #f7f1e3 0%, #efe2c7 45%, #f9f5ec 100%)",
                    }}
                  >
                    {getCertPreviewBg && !getCertBgBroken ? (
                      <img
                        src={getCertPreviewBg}
                        alt=""
                        onError={() => setCertBgBroken(true)}
                        style={{
                          position: "absolute",
                          inset: 0,
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    ) : null}

                    <div
                      style={{
                        position: "absolute",
                        inset: 14,
                        border: "2px solid #c5a46a",
                        borderRadius: 4,
                        pointerEvents: "none",
                        opacity: getCertPreviewBg && !getCertBgBroken ? 0.55 : 1,
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        inset: 20,
                        border: "1px solid rgba(139, 105, 48, 0.45)",
                        borderRadius: 2,
                        pointerEvents: "none",
                        opacity: getCertPreviewBg && !getCertBgBroken ? 0.4 : 1,
                      }}
                    />

                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "6% 8%",
                        textAlign: "center",
                        color: "#2c2416",
                        textShadow:
                          getCertPreviewBg && !getCertBgBroken
                            ? "0 1px 2px rgba(255,255,255,0.85), 0 0 10px rgba(255,255,255,0.7)"
                            : "none",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "clamp(11px, 1.5vw, 14px)",
                          letterSpacing: "0.35em",
                          textTransform: "uppercase",
                          color: "#8b6930",
                          fontWeight: 600,
                          marginBottom: 6,
                        }}
                      >
                        {(GlobalHook.getGlobalSchoolInfo &&
                          GlobalHook.getGlobalSchoolInfo.schoolName) ||
                          "School"}
                      </div>
                      <div
                        style={{
                          fontSize: "clamp(22px, 3.6vw, 34px)",
                          fontWeight: 800,
                          letterSpacing: "0.12em",
                          textTransform: "uppercase",
                          color: "#1f3348",
                          marginBottom: 4,
                        }}
                      >
                        Certificate
                      </div>
                      <div
                        style={{
                          fontSize: "clamp(12px, 1.7vw, 16px)",
                          letterSpacing: "0.28em",
                          textTransform: "uppercase",
                          color: "#8b6930",
                          marginBottom: 18,
                        }}
                      >
                        of Completion
                      </div>
                      <div
                        style={{
                          fontSize: "clamp(11px, 1.4vw, 13px)",
                          color: "#5c5346",
                          marginBottom: 8,
                        }}
                      >
                        This is proudly presented to
                      </div>
                      <div
                        style={{
                          fontSize: "clamp(20px, 3.4vw, 32px)",
                          fontWeight: 700,
                          fontFamily: "Georgia, 'Times New Roman', serif",
                          color: "#1a2740",
                          marginBottom: 10,
                          borderBottom: "2px solid #c5a46a",
                          padding: "0 16px 6px",
                          maxWidth: "90%",
                        }}
                      >
                        {getCertPreviewName || "Student Name"}
                      </div>
                      <div
                        style={{
                          fontSize: "clamp(11px, 1.4vw, 13px)",
                          color: "#5c5346",
                          marginBottom: 6,
                        }}
                      >
                        for successfully completing
                      </div>
                      <div
                        style={{
                          fontSize: "clamp(14px, 2vw, 18px)",
                          fontWeight: 700,
                          color: "#243552",
                          marginBottom: 22,
                          maxWidth: "85%",
                        }}
                      >
                        {(getLocalMatchCourseSchool[0] &&
                          getLocalMatchCourseSchool[0].CourseName) ||
                          "Course Name"}
                      </div>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "0 10%",
                          fontSize: "clamp(11px, 1.4vw, 13px)",
                          color: "#5c5346",
                        }}
                      >
                        <div style={{ textAlign: "center" }}>
                          <div style={{ fontWeight: 700, color: "#243552" }}>
                            {(() => {
                              const d = new Date();
                              return (
                                d.getDate() +
                                " / " +
                                (d.getMonth() + 1) +
                                " / " +
                                d.getFullYear()
                              );
                            })()}
                          </div>
                          <div style={{ marginTop: 2, borderTop: "1px solid #c5a46a", paddingTop: 4 }}>
                            Date
                          </div>
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <div style={{ fontWeight: 700, color: "#243552" }}>
                            {(GlobalHook.getGlobalSchoolInfo &&
                              GlobalHook.getGlobalSchoolInfo.schoolName) ||
                              "School Admin"}
                          </div>
                          <div style={{ marginTop: 2, borderTop: "1px solid #c5a46a", paddingTop: 4 }}>
                            Authorized by
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-gray-500 mt-2" style={{ fontSize: 12 }}>
                    {getCertPreviewBg && !getCertBgBroken
                      ? "Custom background is shown under the certificate text."
                      : "Default designed certificate (no custom background yet). Upload an image to personalize it."}
                  </div>
                </div>

                <p className="text-gray-600" style={{ fontSize: 13 }}>
                  Tip: use a landscape image. After upload, settings are saved automatically.
                  You can also click Save Certificate below.
                </p>
                <button
                  className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
                  style={{ width: 180 }}
                  onClick={() => {
                    saveCertificateSettings(getCertBackground, getCertEnabled);
                  }}
                >
                  Save Certificate
                </button>
              </div>
            </TabPane>

            <TabPane tab="Teachers" key="teachers">
              <div className="font-semibold text-xl mb-4">Teachers</div>
              <div className="flex flex-wrap items-center mb-4" style={{ gap: 8 }}>
                <Input
                  placeholder="Teacher email"
                  value={getTeacherEmail}
                  onChange={(e) => setTeacherEmail(e.target.value)}
                  style={{ width: 280 }}
                />
                <button
                  className="bg-blue-500 text-white px-4 py-2 rounded"
                  onClick={() => {
                    AssignSchoolTeacherAction(
                      GlobalHook,
                      GlobalHook.getGlobalUser.schoolAdminId,
                      getTeacherEmail
                    ).then(() => {
                      setTeacherEmail("");
                      return GetSchoolTeachersAction(GlobalHook.getGlobalUser.schoolAdminId);
                    }).then(setTeacherList);
                  }}
                >
                  Add Teacher
                </button>
              </div>
              <Table
                dataSource={getTeacherList.map((t, i) => ({ ...t, key: t.uid || i }))}
                pagination={false}
              >
                <Column title="Name" dataIndex="name" key="name" />
                <Column title="Email" dataIndex="email" key="email" />
                <Column
                  title="Action"
                  key="action"
                  render={(text, record) => (
                    <a
                      className="text-red-500"
                      onClick={() => {
                        RemoveSchoolTeacherAction(
                          GlobalHook,
                          GlobalHook.getGlobalUser.schoolAdminId,
                          record.uid
                        ).then(() =>
                          GetSchoolTeachersAction(GlobalHook.getGlobalUser.schoolAdminId)
                        ).then(setTeacherList);
                      }}
                    >
                      Remove
                    </a>
                  )}
                />
              </Table>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </>
  );
}
